import { makeStyles } from '@material-ui/core/styles';
import {
    PRIMARY_DARK, TEXT_COLOR, PRIMARY, GRAY_BG, GRAY_LIGHT,
} from '@theme_color';

const useStyles = makeStyles((theme) => ({
    dialogContainerRoot: {
        overflowX: 'hidden',

        '& .MuiDialog-paperScrollPaper': {
            '&::-webkit-overflow-scrolling': 'touch',
            '&::-webkit-scrollbar': {
                height: '.5em',
                width: '.5em',
            },
            '&::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 2px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: TEXT_COLOR,
                borderRadius: 5,
            },
        },
        fontSize: 16,
        textAlign: 'center',
        '& .bold': {
            fontWeight: 600,
        },
        '& .underline': {
            textDecoration: 'underline',
        },
        '& .f20': {
            fontSize: 20,
        },
        '& .mb10': {
            marginBottom: 10,
        },
        '& .py20': {
            padding: '20px 0',
        },
        '& .mb30': {
            marginBottom: 30,
        },
        '& .flex-column': {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
        },
        '& .gap16': {
            gap: 16,
        },
    },
    dialogContainer: {
        '& .MuiDialogContent-root': {
            overflowY: 'visible',
        },
        padding: 30,
        borderRadius: 6,
        position: 'relative',
        overflowX: 'hidden',
    },
    backButton: {
        position: 'absolute',
        color: PRIMARY_DARK,
        padding: 0,
        width: 20,
        height: 20,
        top: 20,
        left: 20,
        [theme.breakpoints.down('xs')]: {
            top: 15,
            left: 15,
        },
    },
    closeButton: {
        position: 'absolute',
        color: PRIMARY_DARK,
        padding: 0,
        width: 20,
        height: 20,
        top: 20,
        right: 20,
        [theme.breakpoints.down('xs')]: {
            top: 15,
            right: 15,
        },
    },
    contentLogo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 30,
        padding: '20px 0',
    },
    content: {
        padding: 0,
        color: PRIMARY_DARK,
        fontSize: 14,
        '&.MuiDialogContent-root': {
            overflowY: 'visible',
        },
        '&.center': {
            disply: 'flex',
            justifyContent: 'center',
        },
    },
    dialogActionRoot: {
        justifyContent: 'center',
        gap: 8,
    },
    btn: {
        padding: '8px 12px',
        width: '100%',
        fontSize: 13,
    },
    mpLogo: {
        width: 32,
    },
    progress: {
        color: PRIMARY,
    },
    dialogTextRoot: {
        color: PRIMARY_DARK,
        fontSize: 14,
        textAlign: 'left',
        padding: '0 8px',
    },
    formField: {
        textAlign: 'left',
        marginBottom: 20,
        fontSize: 14,
        fontWeight: 600,
        '& .isRequired': {
            position: 'relative',
            width: 'fit-content',
            '&::after': {
                content: "'*'",
                display: 'block',
                position: 'absolute',
                top: -1,
                right: -7,
                color: 'red',
                fontSize: 14,
            },
        },
    },
    field: {
        display: 'flex',
        lineHeight: 'normal',
        alignItems: 'center',
        gap: 6,
    },
    textInput: {
        width: '100%',
        '&:hover': {
            '& .MuiInput-underline:before': {
                borderBottom: 'none',
            },
        },
        '& .MuiInput-underline:before': {
            borderBottom: 'none',
        },
        '& .MuiInput-root': {
            backgroundColor: GRAY_BG,
            borderRadius: 6,
            padding: '5px 10px',

        },
        '& .MuiAutocomplete-inputRoot': {
            minHeight: 42,
            borderBottom: 'none',
            paddingTop: 10,
            paddingBottom: 10,
        },
        '& .MuiInput-underline.Mui-disabled:before': {
            borderBottomStyle: 'none',
        },
        '& .MuiInputBase-input::placeholder': {
            color: PRIMARY_DARK,
            fontSize: 13,
        },
    },
    helper: {
        fontWeight: 'normal',
        fontSize: 11,
    },
    tooltip: {
        backgroundColor: 'white',
        color: PRIMARY_DARK,
        minWidth: 110,
        border: `1px solid ${GRAY_LIGHT}`,
        fontSize: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: '8px 10px',
    },
    tooltipPlacementBottom: {
        marginTop: 10,
    },
    tooltipArrow: {
        color: GRAY_LIGHT,
    },
    tooltipButton: {
        color: PRIMARY_DARK,
        padding: 0,
    },
    tooltipIcon: {
        width: 18,
        height: 18,
    },
}));

export default useStyles;
